export const PENDING = 'pending';
export const JOB_CANCELED = 'job_canceled';
export const DELIVERED = 'delivered';
export const PICKED_UP = 'picked_up_shipment';
export const JOB_CLOSED = 'job_closed';
export const EXPOSED = 'exposed';
export const ACCEPTED = 'accepted';
export const SCHEDULED = 'scheduled';


